import { languageCodes, type LanguageCode } from '~/composables/useI18nInfo'

/**
 * 判断当前路由是否是首页
 * @returns 是否是首页
 */
export const useIsHomePage = () => {
  const route = useRoute()
  return computed(() => {
    const segments = route.path.split('/').filter(s => s)
    return (
      segments.length === 0 ||
      (segments.length === 1 && languageCodes.includes(segments[0] as LanguageCode))
    )
  })
}
